// 5.27.3 — apostrophe-insensitive search (Henry 2026-10-20): the ONE rule for every in-browser name filter.
// "oconnor" / "OCONNOR" find "O'Connor" and "o'connor" / "O’Connor" find "OCONNOR": straight ' , curly ’ ‘ and
// backtick ` are ignored on BOTH sides (typed term and text). Nothing else changes — hyphens, periods, spaces and
// every other character match exactly as before (case-insensitive, substring). Mirrors
// backend/services/search_text.py. Display / highlighting is unchanged (it always shows the original text).

export const APOSTROPHES = /['’‘`]/g;

/** Text for comparing: apostrophes removed, lower-cased. */
export const searchFold = (s) => String(s ?? '').replace(APOSTROPHES, '').toLowerCase();

/** Does `text` contain the typed `term`? (Both folded; an empty term matches everything.) */
export const textMatches = (text, term) => searchFold(text).includes(searchFold(term));
